export function usDateFormat(date) {
    const d = new Date(date); // or your date value
    const formattedDate = d.toLocaleDateString('en-US'); // 'en-US' represents the locale for US English
    return formattedDate;
}